import React from 'react';
import { getUrl, getDescText, getPublishDate, getPageDateShort } from '../../common/services/builders';

function JobKnowledgeListerSearchItem({ entry, settings }) {



    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    
                    <span className="category--tag">Job Knowledge</span>
                </div>
                <div className="small-6 column text-right">
                    <span className="category--tag">Public</span>
                </div>
            </div>
            <div className="row column">
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>


                {<span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getPageDateShort(entry)}
                </span>}
            </div>
        </div>
    )
    
}


export default JobKnowledgeListerSearchItem;